// import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf-scrollable.js";
import "./libs/jcf/jcf-select.js";

import { binder, fwa } from "./libs/binder";
import { constants } from "./modules/module";
import { customScroll } from "./modules/customScroll.js";
import { customSelect } from "./modules/customSelect.js";
import { resourcesSlider } from "./modules/resourcesSlider";
import { ourProgramSlider } from "./modules/ourProgramSlider";
import { stepsSlider } from "./modules/stepsSlider";
import { testimonialSlider } from "./modules/testimonialSlider";
import { scrollSlider } from "./modules/scrollSlider";
import { header } from "./modules/header";
import { fullHeightPage } from "./modules/fullHeightPage";
import { popup } from "./modules/popup";
import { heroSlider } from "./modules/heroSlider";
import { animationOnScroll } from "./modules/animationOnScroll";
import { svgAnimation } from "./modules/svgAnimation";
import { quoteSlider } from "./modules/quoteSlider";
import { logoSlider } from "./modules/logoSlider";
import { ourSectionSliders } from "./modules/ourSectionSliders";
import { heartAnimation } from "./modules/heartAnimation";
import { textTemplateVideo, articleVideoClick } from "./modules/textTemplateVideo";
import { mapSection } from "./modules/mapSection";
import { contactUsToggler } from "./modules/contactUs";
import { resourcesHeroSlider } from "./modules/resourcesHeroSlider";
import { accordion, loadMore } from "./modules/accordion";

binder({
    bounds: {
        "html": [constants, fullHeightPage, animationOnScroll],
        body: [],
        ".header": header,
        ".jcf-scrollable": customScroll,
        select: customSelect,
        ".resources-slider-section": resourcesSlider,
        ".our-program-section": ourProgramSlider,
        ".steps-section": stepsSlider,
        ".testimonial-section": [testimonialSlider, popup],
        ".scroll-slider-section": scrollSlider,
        ".hero-section-home": heroSlider,
        ".has-animation-line": svgAnimation,
        ".quote-section": [quoteSlider, popup],
        ".has-logo-slider": logoSlider,
        ".our-section": [ourSectionSliders, popup],
        ".text-template-section": [textTemplateVideo],
        ".heart-animation-box": heartAnimation,
        ".map-section": mapSection,
        ".form-block": contactUsToggler,
        ".resources-hero-slider": resourcesHeroSlider,
        ".accordion": [accordion, loadMore],
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js